import React, { Component } from 'react';

class Placeholder extends Component {
  render(){

    return(
      <div className="img-placeholder">
        <i className="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i>
        <span className="sr-only">Loading...</span>
      </div>
    );
  }
}
export default Placeholder;


// WEBPACK FOOTER //
// ./src/modules/pieces/Placeholder.js